/**
 * Текст для данных вне компонента (массивы слайдов, шагов, конфиги): ключ + английский дефолт.
 *   const TITLE = msg('onboarding.hero.title', 'Build Your Hero');
 *   msg('lootbox.open_another', 'Open another ({{n}})', { n: 3 }) — с параметрами (сериализуемо, можно в redux).
 *   tr(t, TITLE) → перевод (обычная строка возвращается как есть — непереводимые подписи вроде «PvP»).
 * Скрипт scripts/i18n-extract.js находит и t('…', '…'), и msg('…', '…').
 */
export const msg = (key, defaultValue, params) => (params ? { key, defaultValue, params } : { key, defaultValue });

export const tr = (t, value, options) => {
  if (value === null || value === undefined || typeof value === 'string') return value;
  return t(value.key, { defaultValue: value.defaultValue, ...value.params, ...options });
};
